import React, { useState } from 'react';

function cssShadow(s) {
  if (!s) return 'none';
  return `${s.shadowOffset.width}px ${s.shadowOffset.height}px ${s.shadowRadius}px rgba(${hexToRgb(s.shadowColor)},${s.shadowOpacity})`;
}
function hexToRgb(hex) {
  const m = hex.replace('#','').match(/.{2}/g);
  if (!m) return '0,0,0';
  return m.slice(0,3).map(h => parseInt(h,16)).join(',');
}

export default function PhonePreview({ theme, strings }) {
  const [tab, setTab] = useState('home');
  const c = theme.colors;
  const s = theme.spacing;
  const r = theme.radii;
  const sh = theme.shadows;
  const ty = theme.typography;
  const t = (key) => strings[key]?.en || key;

  const screenStyle = {
    background: c.background,
    fontSize: ty.baseSize,
    fontFamily: ty.fontFamily === 'System' ? '-apple-system,Segoe UI,sans-serif' : ty.fontFamily,
    color: c.textPrimary,
  };
  const cardStyle = {
    background: c.surface,
    borderRadius: r.md,
    boxShadow: cssShadow(sh.card),
    border: `1px solid ${c.border}`,
  };
  const btnStyle = {
    background: c.primary,
    color: c.textInverse,
    borderRadius: r.button,
    padding: `${s.sm}px ${s.lg}px`,
  };
  const sectionTitle = {
    fontSize: ty.baseSize + 2,
    fontWeight: 700,
    color: c.textPrimary,
    marginBottom: s.xs,
  };

  return (
    <div className="phone-mockup-screen" style={screenStyle}>
      {/* Status bar */}
      <div className="pm-status-bar" style={{ background: c.backgroundElevated, borderBottom: `1px solid ${c.border}` }}>
        <span style={{ color: c.textPrimary, fontWeight: 600 }}>9:41</span>
        <span style={{ color: c.textMuted, fontSize: 10 }}>OC MENA</span>
      </div>

      {/* Content area */}
      <div className="pm-content" style={{ padding: s.screenPadding }}>
        {tab === 'home' && (
          <div className="pm-tab-content">
            <div style={{ marginBottom: s.md }}>
              <small style={{ color: c.textMuted, fontSize: ty.baseSize - 3, letterSpacing: 1.5, fontWeight: 800 }}>{t('home.ocFair')}</small>
              <h1 style={{ fontSize: ty.headingSize, fontWeight: 800, color: c.textPrimary, margin: `${s.xs}px 0` }}>{t('home.pacificAmp')}</h1>
            </div>

            {/* Hero card */}
            <div style={{ ...cardStyle, padding: s.md, marginBottom: s.md, background: `linear-gradient(135deg,${c.gradientHero[0]},${c.gradientHero[1]})` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: s.sm }}>
                <div>
                  <div style={{ fontSize: ty.baseSize - 2, color: c.textSecondary }}>{t('home.buyFestivalSub')}</div>
                  <strong style={{ fontSize: ty.baseSize + 4, color: c.textPrimary }}>{t('home.buyFestivalTickets')}</strong>
                </div>
                <div style={{ ...btnStyle, fontSize: ty.baseSize - 2 }}>{t('home.buyFestivalTickets')}</div>
              </div>
              <div style={{ display: 'flex', gap: s.xs }}>
                {['Jun 19','Jun 20','Jun 21'].map(d => (
                  <span key={d} style={{ background: c.goldSoft, color: c.gold, borderRadius: r.sm, padding: `${s.xs}px ${s.sm}px`, fontSize: ty.baseSize - 3, fontWeight: 700 }}>{d}</span>
                ))}
              </div>
            </div>

            {/* Concert card */}
            <div style={{ ...cardStyle, padding: s.md, marginBottom: s.md }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: ty.baseSize - 2, color: c.textSecondary }}>{t('home.buyConcertSub')}</div>
                  <strong style={{ fontSize: ty.baseSize + 2, color: c.textPrimary }}>{t('home.buyConcertTickets')}</strong>
                </div>
              </div>
            </div>

            <div style={sectionTitle}>{t('home.performing')}</div>
            <div style={{ display: 'flex', gap: s.sm, overflow: 'hidden' }}>
              {[1,2,3].map(i => (
                <div key={i} style={{ ...cardStyle, width: 100, padding: s.sm, flexShrink: 0 }}>
                  <div style={{ width: '100%', aspectRatio: 1, borderRadius: r.sm, background: `linear-gradient(135deg,${c.gradientPrimary[0]},${c.gradientPrimary[1]})`, marginBottom: s.xs }} />
                  <div style={{ fontSize: ty.baseSize - 3, fontWeight: 700, color: c.textPrimary }}>Artist {i}</div>
                  <div style={{ fontSize: ty.baseSize - 4, color: c.textMuted }}>{t('home.headliner')}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab === 'tickets' && (
          <div className="pm-tab-content">
            <h1 style={{ fontSize: ty.headingSize, fontWeight: 800, marginBottom: s.md }}>{t('tickets.title')}</h1>
            <div style={{ display: 'flex', gap: s.sm, marginBottom: s.md }}>
              <span style={{ background: c.primary, color: c.textInverse, borderRadius: r.pill, padding: `${s.xs}px ${s.md}px`, fontSize: ty.baseSize - 2, fontWeight: 700 }}>{t('tickets.activeTab')}</span>
              <span style={{ background: c.surfaceAlt, color: c.textSecondary, borderRadius: r.pill, padding: `${s.xs}px ${s.md}px`, fontSize: ty.baseSize - 2, fontWeight: 700 }}>{t('tickets.otherTab')}</span>
            </div>
            <div style={{ ...cardStyle, padding: s.lg, textAlign: 'center' }}>
              <div style={{ width: 48, height: 48, borderRadius: r.pill, background: c.surfaceAlt, margin: '0 auto', marginBottom: s.sm, display: 'grid', placeItems: 'center', fontSize: 22 }}>🎫</div>
              <div style={{ fontWeight: 700, color: c.textPrimary, marginBottom: s.xs }}>{t('tickets.noActive')}</div>
              <div style={{ fontSize: ty.baseSize - 2, color: c.textMuted, lineHeight: 1.5 }}>{t('tickets.activeDesc')}</div>
            </div>
          </div>
        )}

        {tab === 'info' && (
          <div className="pm-tab-content">
            <h1 style={{ fontSize: ty.headingSize, fontWeight: 800, marginBottom: s.md }}>{t('info.title')}</h1>
            <div style={{ ...cardStyle, padding: s.md, marginBottom: s.sm }}>
              <strong style={{ fontSize: ty.baseSize, color: c.textPrimary }}>{t('info.lineup')}</strong>
              <div style={{ display: 'flex', gap: s.xs, marginTop: s.sm }}>
                {['Festival','Concert'].map(x => (
                  <span key={x} style={{ background: c.accentLight, color: c.accent, borderRadius: r.sm, padding: `${s.xs}px ${s.sm}px`, fontSize: ty.baseSize - 3, fontWeight: 700 }}>{x}</span>
                ))}
              </div>
            </div>
            <div style={{ ...cardStyle, padding: s.md, marginBottom: s.sm }}>
              <strong style={{ fontSize: ty.baseSize, color: c.textPrimary }}>{t('info.generalInfo')}</strong>
              <div style={{ marginTop: s.sm, fontSize: ty.baseSize - 2, color: c.textSecondary, lineHeight: 1.6 }}>{t('info.ampNotice')}</div>
            </div>
            <div style={{ ...cardStyle, padding: s.md }}>
              <strong style={{ fontSize: ty.baseSize, color: c.textPrimary }}>{t('info.hours')}</strong>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: s.sm, fontSize: ty.baseSize - 2, color: c.textSecondary }}>
                <span>{t('info.parkingOpens')}</span><span>10:00 AM</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: s.xs, fontSize: ty.baseSize - 2, color: c.textSecondary }}>
                <span>{t('info.groundsOpen')}</span><span>12:00 PM</span>
              </div>
            </div>
          </div>
        )}

        {tab === 'profile' && (
          <div className="pm-tab-content">
            <h1 style={{ fontSize: ty.headingSize, fontWeight: 800, marginBottom: s.md }}>{t('profile.title')}</h1>
            <div style={{ ...cardStyle, padding: s.md, marginBottom: s.sm, display: 'flex', alignItems: 'center', gap: s.md }}>
              <div style={{ width: 56, height: 56, borderRadius: r.pill, background: `linear-gradient(135deg,${c.gradientPrimary[0]},${c.gradientPrimary[1]})`, flexShrink: 0 }} />
              <div>
                <strong style={{ fontSize: ty.baseSize + 2, color: c.textPrimary }}>John Doe</strong>
                <div style={{ fontSize: ty.baseSize - 2, color: c.textMuted }}>john@example.com</div>
              </div>
            </div>
            {[
              [t('profile.accountSettings'), t('profile.accountSettingsSub')],
              [t('profile.notifications'), t('profile.notificationsSub')],
              [t('profile.transferHistory'), t('profile.transferHistorySub')],
              [t('profile.language'), t('profile.languageSub')],
            ].map(([title, sub]) => (
              <div key={title} style={{ ...cardStyle, padding: s.md, marginBottom: s.xs, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 700, color: c.textPrimary, fontSize: ty.baseSize - 1 }}>{title}</div>
                  <div style={{ fontSize: ty.baseSize - 3, color: c.textMuted }}>{sub}</div>
                </div>
                <span style={{ color: c.textMuted, fontSize: 18 }}>›</span>
              </div>
            ))}
            <div style={{ ...cardStyle, padding: s.md, marginTop: s.sm, textAlign: 'center', borderColor: c.danger }}>
              <strong style={{ color: c.danger, fontSize: ty.baseSize - 1 }}>{t('profile.logout')}</strong>
            </div>
          </div>
        )}
      </div>

      {/* Tab bar */}
      <div className="pm-tab-bar" style={{ background: c.backgroundElevated, borderTop: `1px solid ${c.border}` }}>
        {[
          ['home', t('tab.home')],
          ['tickets', t('tab.tickets')],
          ['info', t('tab.info')],
          ['profile', t('tab.profile')],
        ].map(([key, label]) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className="pm-tab-btn"
            style={{
              color: tab === key ? c.primary : c.textMuted,
              fontWeight: tab === key ? 700 : 500,
              fontSize: ty.baseSize - 3,
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
